module.exports = __webpack_public_path__ + "static/img/icon-enn-item1.f6f44be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enn-item1.png
// module id = CyHU
// module chunks = 21